<template>
  <div class="filters">
    <filter-row :rowFilters="rowFilters" :filters="filters"></filter-row>
    <filter-box
      v-if="filters"
      :rowFilters="rowFilters"
      :locationTotalCount="locationTotalCount"
      class="show-on-mobile"
      :filters="filters"
    ></filter-box>
  </div>
</template>

<script>
import FilterBox from './filter-box.vue';
import FilterRow from './filter-row.vue';
import * as _ from 'lodash-es';
import { defineAsyncComponent } from 'vue';

export default {
  name: 'filters',
  data: () => ({
    rowFilters: {
      // By default all filters are shown so that v-model defaults work as expected
      productGroups: true,
      location: true,
      livingArea: true,
      priceRange: true,
      numberOfRooms: true,
      condition: true,
      listingTypes: true,
      extraFeatures: true,
      yearRange: true,
      propertyId: true,
      showings: true,
      siteOwnership: true,
      energy: true,
    },
  }),
  props: {
    locationTotalCount: {
      type: Number,
      required: false,
      default: 0,
    },
    filters: {
      type: Object,
      required: false,
      default: {},
    },
  },
  methods: {
    setFilterVisibilities() {
      const windowWidth = window.innerWidth;
      const breakPoints = [
        {
          breakpoint: 1680,
          settings: {
            featureGroup: true,
            location: true,
            priceMin: true,
            livingAreaMin: true,
            siteAreaMin: true,
            totalAreaMin: true,
            rentMin: true,
            numberOfRooms: true,
            condition: false,
            listingTypes: true,
            extraFeatures: true,
            yearMin: false,
            propertyId: false,
            showings: false,
            siteOwnership: false,
            energy: false,
          },
        },
        {
          breakpoint: 1400,
          settings: {
            featureGroup: true,
            location: true,
            priceMin: true,
            livingAreaMin: true,
            siteAreaMin: true,
            totalAreaMin: true,
            rentMin: true,
            numberOfRooms: true,
            condition: false,
            listingTypes: true,
            extraFeatures: false,
            yearMin: false,
            propertyId: false,
            showings: false,
            siteOwnership: false,
            energy: false,
          },
        },
        {
          breakpoint: 1300,
          settings: {
            featureGroup: true,
            location: true,
            priceMin: true,
            livingAreaMin: true,
            siteAreaMin: true,
            totalAreaMin: true,
            rentMin: true,
            numberOfRooms: true,
            condition: false,
            listingTypes: true,
            extraFeatures: false,
            yearMin: false,
            propertyId: false,
            showings: false,
            siteOwnership: false,
            energy: false,
          },
        },
        {
          breakpoint: 1023,
          settings: {
            featureGroup: true,
            location: true,
            priceMin: true,
            livingAreaMin: true,
            siteAreaMin: true,
            totalAreaMin: true,
            rentMin: true,
            numberOfRooms: false,
            condition: false,
            listingTypes: false,
            extraFeatures: false,
            yearMin: false,
            propertyId: false,
            showings: false,
            siteOwnership: false,
            energy: false,
          },
        },
        {
          breakpoint: 0,
          settings: {
            featureGroup: false,
            location: false,
            priceMin: false,
            livingArea: false,
            siteAreaMin: false,
            totalAreaMin: false,
            rentMin: false,
            numberOfRooms: false,
            condition: false,
            listingTypes: false,
            extraFeatures: false,
            yearMin: false,
            propertyId: false,
            showings: false,
            siteOwnership: false,
            energy: false,
          },
        },
      ];
      const correctBreakpoint = _.find(
        breakPoints,
        (point) => windowWidth > point.breakpoint || point.breakpoint === 0
      );
      this.rowFilters = correctBreakpoint ? correctBreakpoint.settings : this.rowFilters;
    },
  },
  watch: {
    $route(to, from) {
      this.$bus.$off(`windowResized-${from.path}`);
      this.$bus.$on(`windowResized-${to.path}`, () => {
        this.setFilterVisibilities();
      });
    },
  },
  mounted() {
    this.setFilterVisibilities();
    this.$bus.$on(`windowResized-${this.$route.path}`, () => {
      this.setFilterVisibilities();
    });
  },
  beforeUnmount() {
    this.$bus.$off(`windowResized-${this.$route.path}`);
  },
  components: {
    FormButton: defineAsyncComponent(() => import('@/app/components/form-button/form-button.vue')),
    FilterBox,
    FilterRow,
  },
};
</script>
